import { Button as AntButton } from 'antd';
import styled from 'styled-components';

export const Button = ({
    children,
    $gap = '8px',
    $size = '14px',
    $padding = '10px 14px',
    $primary = true,
    $hoverShadow = true,
    $hoverAnimation = false,
    ...props
}) => {
    return (
        <StyledButton
            $size={$size}
            $gap={$gap}
            $padding={$padding}
            $primary={$primary}
            $hoverShadow={$hoverShadow}
            $hoverAnimation={$hoverAnimation}
            {...props}
        >
            {children}
        </StyledButton>
    );
};

export const StyledButton = styled(AntButton)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ $gap }) => $gap && `${$gap} !important`};
    padding: ${({ $padding }) => $padding && `${$padding} !important`};
    border-radius: 12px;
    font-size: ${({ $size }) => $size ? $size : '14px'};
    font-weight: 600;
    font-family: var(--font-family-lufga);
    height: auto;

    @media (max-width: 1024px) {
        font-size: ${({ $size }) => $size ? `calc(${$size} * 0.95)` : '14px'};
        padding: ${({ $padding }) => {
        if (!$padding) return '20px 28px !important';
        const [vertical, horizontal] = $padding.split(' ');
        return `calc(${vertical} * 0.85) calc(${horizontal} * 0.85) !important`;
    }};
        gap: ${({ $gap }) => $gap ? `calc(${$gap} * 0.9) !important` : '8px !important'};
        
        .anticon {
            font-size: calc(1em * 0.9);
        }
    }

    @media (max-width: 768px) {
        font-size: ${({ $size }) => $size ? `calc(${$size} * 0.92)` : '13px'};
        padding: ${({ $padding }) => {
        if (!$padding) return '18px 24px !important';
        const [vertical, horizontal] = $padding.split(' ');
        return `calc(${vertical} * 0.75) calc(${horizontal} * 0.75) !important`;
    }};
        gap: ${({ $gap }) => $gap ? `calc(${$gap} * 0.85) !important` : '8px !important'};
        border-radius: 12px;
        
        .anticon {
            font-size: calc(1em * 0.85);
        }
    }

    @media (max-width: 480px) {
        font-size: ${({ $size }) => $size ? `calc(${$size} * 0.9)` : '12px'};
        padding: ${({ $padding }) => {
        if (!$padding) return '16px 20px !important';
        const [vertical, horizontal] = $padding.split(' ');
        return `calc(${vertical} * 0.65) calc(${horizontal} * 0.65) !important`;
    }};
        gap: ${({ $gap }) => $gap ? `calc(${$gap} * 0.8) !important` : '8px !important'};
        border-radius: 10px;
        
        .anticon {
            font-size: calc(1em * 0.8);
        }
    }
    background-color: ${({ theme, $primary }) => {
        if ($primary) {
            return theme.colors.primary;
        }
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#ffffff';
    }};
    color: ${({ theme, $primary }) => {
        if ($primary) {
            return '#ffffff';
        }
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
    border: ${({ theme, $primary }) => {
        if ($primary) {
            return `1px solid ${theme.colors.primary}`;
        }
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '1px solid transparent' : '1px solid #E5E5E5';
    }};
    transition: ${({ $hoverAnimation }) => $hoverAnimation ? 'box-shadow 0.3s ease, background-color 0.3s ease, color 0.3s ease, transform 0.3s ease' : 'none'};
    box-shadow: none;
    transform: scale(1);
    
    &:hover {
        background-color: ${({ theme, $primary }) => {
        if ($primary) {
            return theme.colors.primary;
        }
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#ffffff';
    }} !important;
        color: ${({ theme, $primary }) => {
        if ($primary) {
            return '#ffffff';
        }
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }} !important;
        border: ${({ theme, $primary }) => {
        if ($primary) {
            return `1px solid ${theme.colors.primary}`;
        }
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '1px solid transparent' : '1px solid #E5E5E5';
    }} !important;
        box-shadow: ${({ $primary, $hoverShadow }) => {
        if ($hoverShadow) {
            if ($primary) {
                return '0 4px 12px rgba(240, 74, 74, 0.3)';
            }
            return '0 2px 8px rgba(0, 0, 0, 0.15)';
        }
        return 'none';
    }};
        transform: ${({ $hoverAnimation }) => $hoverAnimation ? 'scale(1.02)' : 'scale(1)'};
    }
    
    &:active {
        transform: ${({ $hoverAnimation }) => $hoverAnimation ? 'scale(0.98)' : 'scale(1)'};
    }

    &:disabled,
    &.ant-btn-disabled {
        cursor: not-allowed !important;
        opacity: 0.65;
        box-shadow: none !important;
        transform: scale(1) !important;
    }

    &:disabled:hover,
    &.ant-btn-disabled:hover {
        box-shadow: none !important;
    }
`;